import { render, staticRenderFns } from "./PriceTableList.vue?vue&type=template&id=3b1dd61a&"
import script from "./PriceTableList.vue?vue&type=script&lang=js&"
export * from "./PriceTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports